<template>
  <div class="flex">
    <div class="single-choice-item choice-item cursor-pointer flex-1">
      <div>
        <adapter-radio class="px-3 py-2.5" :disabled="disabled" :label="item.id" :rich-text="itemText" :tip="item.tips">
          <div v-html="itemText" class="text-medium leading-base" ref="text"></div>
        </adapter-radio>
      </div>
      <template v-if="selected">
        <relation-input
          class="mt-1 px-3 pb-2"
          v-if="item.is_other_item"
          :type="item.inputType"
          v-model="item.value"
          :option-id="item.id"
          :question-id="questionId"
          :question-type="questionType"
          :enable-relation="enableRelation"
          :max-length="item.maxLength"
          :min-length="item.minLength"
          :validate="item.validate"
          :enabled-error-tip="enabledErrorTip"
          :allow-error-list="item.allowErrorList"
          :placeholder="item.placeholder"
        />
        <!--      <el-input-->
        <!--        v-if="item.is_other_item"-->
        <!--        :type="item.inputType === 'number' ? 'text' : item.inputType"-->
        <!--        class="mt-1"-->
        <!--        v-model="item.value"-->
        <!--        placeholder="请输入"-->
        <!--      />-->
        <adapter-upload-files :content="item.content" class="mb-2" />
      </template>
      <slot name="vote" />
    </div>
    <div style="width: 100px" v-if="correctAnswerList.length">
      <template v-if="correct">
        <div class="flex flex-col text-center py-2">
          <span v-if="correct.score" class="text-theme-black-450 text-medium">{{ correct.score }}分</span>
          <span class="text-green-theme text-medium">正确答案</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AdapterUploadFiles from '@/questions/components/AdapterUploadFiles'
import AdapterRadio from '@/questions/components/Adapter/AdapterRadio'
import RelationInput from '@/questions/components/RelationInput'
import { appendQuotaText, ValidateType } from 'dygc'

export default {
  name: 'SingleChoiceItem',
  components: { RelationInput, AdapterRadio, AdapterUploadFiles },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    },
    correctAnswerList: {
      type: Array,
      default: () => []
    },
    questionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enabledErrorTip(){
      if(this.item.validate !== ValidateType.NUM) return true
      return this.item.outOfRange !== 1
    },
    disabled() {
      if (this.item.showQuotaCount) {
        if (this.item.count === 0) return true
      }
      return this.item.disabled
    },
    itemText() {
      const content = this.item.content
      return content.richText || content.text
    },
    correct() {
      return this.correctAnswerList.find(i => i.id === this.item.id)
    },
    isCorrect() {
      return !!this.correctAnswerList.find(i => i.id === this.item.id)
    }
  },
  methods: {
    initAppendText() {
      const el = this.$refs.text
      if (!el) return
      if (this.item.showQuotaCount) {
        appendQuotaText(el, this.item.count, this.disabled)
      }
    }
  },
  mounted() {
    this.initAppendText()
  }
}
</script>

<style scoped></style>
